import Hero from "@/components/sections/Hero";
import ValueStrip from "@/components/sections/ValueStrip";
import Problem from "@/components/sections/Problem";
import CoreValue from "@/components/sections/CoreValue";
import Marquee from "@/components/sections/Marquee";
import Manifesto from "@/components/sections/Manifesto";
import AudienceSplit from "@/components/sections/AudienceSplit";
import Features from "@/components/sections/Features";
import Competitive from "@/components/sections/Competitive";
import HowItWorks from "@/components/sections/HowItWorks";
import Outcomes from "@/components/sections/Outcomes";
import Pricing from "@/components/sections/Pricing";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <ValueStrip />
      <Problem />
      <CoreValue />
      <Manifesto />
      <AudienceSplit />
      <Features />
      <Competitive />
      <HowItWorks />
      <Outcomes />
      <Pricing />
      <FAQ />
      <FinalCTA />
    </div>
  );
}
